import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  connect() {
    console.log("conectanto new paymant controller");
  }

  cleanQuantityInput() {
    console.log("testing");
    const manualItem = document.querySelector(
      "#payment_payment_items_quantity"
    );

    // console.log(existingItem);
    // existingItem.value = existingItem.replace(",", "");
    manualItem.value = manualItem.value.replace(/[,\s]/g, "");
  }
  cleanQuantityInput1() {
    const existingItem = document.querySelector(
      "#payment_payment_items_quantity_item_types"
    );
    existingItem.value = existingItem.value.replace(/[.,\s]/g, "");
  }

  replaceCommaInput() {
    const amount = document.querySelector("#payment_payment_items_amount");
    amount.value = amount.value.replace(/[,\s]/g, ".");
  }
}
